import React from 'react'
import useCheckDynamicPowerPriceApplicability from '../hooks/use-check-dynamic-power-price-applicability'
import { DynamicPowerPricesEnabledContext } from './dynamic-power-prices-enabled-context'
import { DynamicPowerPricesEnabledContextProps } from '../types'
import { useTypedSelector } from 'src/State/RootReducer'

interface Props {
  children: React.ReactElement
}

/**
 * Context provider to share if dynamic power prices are enabled or applicable
 *
 * @param param0
 * @returns
 */
const DynamicPowerPricesEnabledProvider: React.FC<Props> = ({ children }) => {
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const storageId = activeStorage?.toString() ?? ''
  const value = useCheckDynamicPowerPriceApplicability(storageId)

  return <DynamicPowerPricesEnabledContext.Provider value={value}>{children}</DynamicPowerPricesEnabledContext.Provider>
}

export default DynamicPowerPricesEnabledProvider

export const useDynamicPowerPricesEnabledContext = (): DynamicPowerPricesEnabledContextProps => React.useContext(DynamicPowerPricesEnabledContext)
